import { AutogenLayoutJobClassificationList } from "./autogen/AutogenLayoutJobClassificationList";
import { TableRow } from "@mcleod/components";

export class JobClassificationList extends AutogenLayoutJobClassificationList {
    onLoad(): void | Promise<void> {
        this.mainDataSource.orderBy = [{ field: "id", sort: "asc" }];
        this.tableJobClassifications.overrideUrlParams = (selectedRow: TableRow) => {
            return {
                key: selectedRow.data.get("id"),
                terminalId: selectedRow.data.get("terminal_id"),
                divisionId: selectedRow.data.get("division_id")
            };
        };
    }
}
